import { FC } from "react";
import { useNavigate } from "react-router-dom";

type Props = {
  /** Only when the booking is still in memory and just the payment step was lost. */
  showPaymentOptions?: boolean;
};

/**
 * Shown when a refresh left the flow without a booking/payment context. Offers a
 * safe restart and support instead of letting the user pay against unknown state.
 */
const BookingRecoveryNotice: FC<Props> = ({ showPaymentOptions = false }) => {
  const navigate = useNavigate();

  return (
    <div
      role="alert"
      className="border border-gray-200 rounded-xl p-4 my-4 text-left flex flex-col gap-2"
    >
      <div className="font-medium">We couldn’t restore your booking</div>
      <div className="text-gray-500 text-sm">
        Your flight details weren’t carried over. If you already attempted
        payment, check Your Flights or contact support before trying again.
      </div>
      <div className="flex flex-wrap gap-4 text-sm">
        {showPaymentOptions && (
          <button
            type="button"
            onClick={() => navigate("/aviation/select-payment-method")}
            className="font-medium underline"
          >
            Back to payment options
          </button>
        )}
        <button
          type="button"
          onClick={() => navigate("/aviation/your-flights")}
          className="font-medium underline"
        >
          Your Flights
        </button>
        <button
          type="button"
          onClick={() => navigate("/aviation/new-local-flight")}
          className="font-medium underline"
        >
          Start a new flight search
        </button>
        <a
          href="mailto:support@visaro.ng?subject=Local%20flight%20booking%20recovery"
          className="font-medium underline"
        >
          Contact support
        </a>
      </div>
    </div>
  );
};

export default BookingRecoveryNotice;
